// catalog
export const PRODUCT_EVENT_TYPE = 'event';
export const PRODUCT_EVENT_TYPES = 'events';
export const PRODUCT_ONLINE_EVENT_TYPE = 'online_event';
// export const PRODUCT_ONLINE_EVENT_TAXON_ID = import.meta.env.PRODUCT_ONLINE_EVENT_TAXON_ID;
export const PRODUCT_ONLINE_EVENT_TAXON_ID = 147;
export const PRODUCT_ONLINE_EVENT_TYPES = 'online_events';
export const PRODUCT_MATERIAL_TYPE = 'material_kit';
export const PRODUCT_GIFTCARD_TYPE = 'giftcard';
export const PRODUCT_GIFTBOX_TYPE = 'gift_box';
export const PRODUCT_BUNDLE_TYPE = 'product_bundle';
export const PRODUCT_VIDEO_COURSE_TYPE = 'video_course';

// PLP Filters
export const FILTER_SKILL = 'variants_skill';
export const FILTER_HOST = 'variants_hostUuid';
export const FILTER_THEME = 'variants_themeUuid';
export const FILTER_THEME_CATEGORY = 'variants_themeCategories_uuid';
export const FILTER_DATE = 'variants_eventTimestamp';
export const FILTER_CITY = 'variants_mainTaxonCodes';
export const FILTER_ORDER_BY = 'variants_orderBy';
export const FILTERS_KEYS = [
  FILTER_SKILL,
  FILTER_THEME_CATEGORY,
  FILTER_THEME,
  FILTER_HOST,
  FILTER_DATE,
  FILTER_CITY,
  FILTER_ORDER_BY
];

// CSS var
export const TEXT_COLORS = ['gray-9', 'gray-8', 'gray-7', 'gray-6', 'primary', 'white'];
export const TEXT_HEADINGS_STYLES = ['display', 'heading-1', 'heading-2', 'heading-3', 'heading-4', 'heading-5'];
export const TEXT_SHADOWS = ['display', 'heading-1', 'heading-2', 'heading-3', 'heading-4', 'heading-5'];
export const TEXT_STYLES = [
  'body',
  'small-body',
  'additional-1',
  'additional-2',
  'additional-3',
  'additional-4',
  'label',
  'display'
];

// local storage
export const TY_STORAGE_KEY = 'TY/loaded/{cart_id}';
export const TY_LAST_ORDER = 'TY/last-order';
export const TY_RESULTS_KEY = 'TY/results/{cart_id}';
export const TY_ORDER_KEY = 'TY/order/{cart_id}';
export const CITY_MODAL_SELECTED = 'city-modal-select';
export const SELECTED_THEME = 'selected-theme';
export const REBOOKING_ORDER_NUMBER = 'rebooking-order-number';
export const REBOOKING_EVENT_ID = 'rebooking-event-id';
export const CART_COOKIE_NAME = 'vsf-cart';
export const LS_KEY = 'vsf-user';
export const LS_KEY_TOKEN = 'auth-token';
export const LS_KEY_REFRESH_TOKEN = 'auth-refresh-token';
export const CONFIRMED_EMAIL = 'confirmed-email';
export const GETTERMS_COOKIE_CONSENT = 'getterms_cookie_consent';
export const SOLDOUT_CITY_SLUG = 'soldout-city-slug';

// group booking
export const MIN_PARTICIPANTS = 10;
export const MAX_PARTICIPANTS = 25;
export const GROUP_BOOKING_PRICE = 49;
export const MIN_PARTICIPANTS_COUNTER = 1;
export const MAX_PARTICIPANTS_COUNTER = 50;
export const MAX_BOOKABLE_DAYS = 14;

// routes
export const MOTIV_PATH = '/motiv';
export const ONLINE_PRODUCTS_PATH = '/online-events';
export const EVENTS_PATH = '/events';
export const CHECKOUT_PATH = '/checkout';
export const PAYMENT_ERROR_PATH = '/payment-error';
export const TICKET_REBOOKING_PATH = '/ticketumbuchung';
export const ROOT_PATH = '/';
export const VARIABLE_ROUTE_TYPE = 'variable-route';
export const KIDS_PRODUCTS_PATH = '/malen-mit-kindern';
export const VOUCHER_PRODUCTS_PATH = '/malkurs-gutschein';
export const GROUP_PRODUCTS_PATH = '/gruppenevents';
export const THEMES_PATH = 'motiv?themeCategories_uuid=';
export const ANGEBOT_PATH = '/angebot';
export const COOKIES_PATH = '/cookies';

// export const AQUARELL_PATH=""
export const THEMES_ROUTE_TYPE = 'themes-route';
export const EVENTS_ROUTE_TYPE = 'events-route';
export const KIDS_ROUTE_TYPE = 'malen-mit-kindern';

//slug
export const MOTIV_SLUG_MALEN_ID = 'motiv-slug-malen-id';
export const EVENTS_SLUG = 'events-slug';
export const ONLINE_EVENTS_SLUG = 'online-events';
